module.exports = __webpack_public_path__ + "img/tap_to_start.49e4fd19.png";